import type { CollectiveCategory, CollectiveCategoryId } from './types';

export const COLLECTIVE_CATEGORIES: readonly CollectiveCategory[] = [
  {
    id: 'climatetech',
    label: 'Climate & Clean Tech',
    blurb: 'Ventures cutting carbon — energy, fuel, materials, reforestation.',
  },
  {
    id: 'makers',
    label: 'Design & Fabrication',
    blurb: 'Studios and shops turning materials into finished product.',
  },
  {
    id: 'studios',
    label: 'Creative & Media Studios',
    blurb: 'Designers, producers, and agencies working to commission.',
  },
  {
    id: 'recreation',
    label: 'Sport, Events & Hospitality',
    blurb: 'Where the building gathers, plays, and celebrates.',
  },
  {
    id: 'ventures',
    label: 'Software & Ventures',
    blurb: 'Founders building software and young companies.',
  },
  {
    id: 'services',
    label: 'Professional & Community Services',
    blurb: 'Specialists, trainers, and advisors you book.',
  },
];

export const CATEGORY_LABEL: Record<CollectiveCategoryId, string> = {
  climatetech: 'Climate & Clean Tech',
  makers: 'Design & Fabrication',
  studios: 'Creative & Media Studios',
  recreation: 'Sport, Events & Hospitality',
  ventures: 'Software & Ventures',
  services: 'Professional & Community Services',
};
